import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ArticleDesign, ArticleDisplay, ArticleSpecial } from '@guardian/libs';
import { RichLink } from '@root/src/web/components/RichLink';
const defaultImageData = {
    thumbnailUrl: '',
    altText: '',
    width: '',
    height: '',
};
export const DefaultRichLink = ({ index, headlineText, url, isPlaceholder, }) => {
    return (_jsx(RichLink, { richLinkIndex: index, cardStyle: "news", imageData: defaultImageData, headlineText: headlineText, contentType: "article", url: url, format: {
            display: ArticleDisplay.Standard,
            design: ArticleDesign.Standard,
            // We default to SpecialReport here purely because the greys of this theme
            // look better as the defaults
            theme: ArticleSpecial.SpecialReport,
        }, tags: [], sponsorName: "", isPlaceholder: isPlaceholder }, void 0));
};
